import { IReactionDisposer } from 'mobx';

export default abstract class Store {
  reactions: { [key: string]: IReactionDisposer } = {};

  destroy() {
    Object.keys(this.reactions).map(key => this.reactions[key]());
  }
}
